import { render, staticRenderFns } from "./Pianificazione.vue?vue&type=template&id=4be4d519&scoped=true&"
import script from "./Pianificazione.vue?vue&type=script&lang=js&"
export * from "./Pianificazione.vue?vue&type=script&lang=js&"
import style0 from "./Pianificazione.vue?vue&type=style&index=0&id=4be4d519&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be4d519",
  null
  
)

export default component.exports